import { cn } from "@utils/tw"
import { ComponentProps, forwardRef } from "react"

export const ImageCaption = forwardRef<HTMLParagraphElement, ComponentProps<"p">>((props, ref) => {
  return (
    <p
      {...props}
      ref={ref}
      className={cn("type-body-s text-fg/50 mt-3 mb-6 md:mb-3 px-grid-margin md:px-0 max-w-[60em]", props.className)}
    />
  )
})
